var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getSearchEndpoint } from '../utils/endpointProviders';
/**
 * Responsible for reporting Analytics events.
 *
 * @public
 */
var SearchAnalyticsReporter = /** @class */ (function () {
    function SearchAnalyticsReporter(config, httpRequesterService) {
        this.config = config;
        this.httpRequesterService = httpRequesterService;
        this.setVisitor(config.visitor);
        this._debug = config.debug;
        this._endpoint = getSearchEndpoint(this.config.businessId, this.config.region, this.config.env, this.config.domain);
    }
    /**
     * Prints event details to the console for debugging of analytics events as they fire.
     * @param event - the SearchAnalyticsEvent that will be printed
     */
    SearchAnalyticsReporter.prototype.printEvent = function (event) {
        if (!this._debug)
            return;
        console.log("%c[YextAnalytics]%c- Tracked Search event: ".concat(event.type), 'background: white; color: blue;', '');
    };
    /** {@inheritDoc AnalyticsService.report} */
    SearchAnalyticsReporter.prototype.report = function (event, additionalRequestAttributes) {
        return __awaiter(this, void 0, void 0, function () {
            var type, eventData, data, res, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = event.type, eventData = __rest(event, ["type"]);
                        data = __assign(__assign({ eventType: type, businessId: this.config.businessId, experienceKey: this.config.experienceKey, experienceVersion: this.config.experienceVersion }, (this._visitor && { visitor: __assign({}, this._visitor) })), SearchAnalyticsReporter._formatForApi(eventData));
                        return [4 /*yield*/, this.httpRequesterService.post(this._endpoint, __assign({ data: data }, additionalRequestAttributes))];
                    case 1:
                        res = _a.sent();
                        if (!(res.status !== 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.text()];
                    case 2:
                        errorMessage = _a.sent();
                        throw new Error(errorMessage);
                    case 3:
                        this.printEvent(event);
                        return [2 /*return*/];
                }
            });
        });
    };
    /** {@inheritDoc AnalyticsService.setVisitor} */
    SearchAnalyticsReporter.prototype.setVisitor = function (visitor) {
        this._visitor = visitor;
    };
    /**
     * Formats the event data for the api which includes adapting verticalKey to verticalConfigId.
     *
     * @param event - The data to format.
     * @returns The formatted data.
     */
    SearchAnalyticsReporter._formatForApi = function (event) {
        var transformedEvent = __assign({}, event);
        if (transformedEvent.verticalKey) {
            transformedEvent.verticalConfigId = transformedEvent.verticalKey;
            delete transformedEvent.verticalKey;
        }
        return transformedEvent;
    };
    /** {@inheritDoc SearchAnalyticsService.setDebugEnabled} */
    SearchAnalyticsReporter.prototype.setDebugEnabled = function (enabled) {
        this._debug = enabled;
    };
    return SearchAnalyticsReporter;
}());
export { SearchAnalyticsReporter };
//# sourceMappingURL=SearchAnalyticsReporter.js.map